<template>
  <template v-if="props.contrat.typeSignatureId == 1">
    <refonte-item-file-formateur-contrat
      v-if="props.contrat.documentASigner"
      v-bind:title="props.title"
      v-bind:subtitle="props.subtitle"
      v-bind:contrat="props.contrat"
      v-bind:on_click_download="
        () => downloadContrat(props.contrat.clientId, props.contrat)
      "
      v-bind:on_close="props.on_close"
      v-bind:on_submit="props.on_submit"
      v-bind:client_id="props.contrat.clientId"
      v-bind:participant_nom_prenom="props.participant_nom_prenom"
      v-bind:session_date="props.session_date"
      v-bind:formation_title="props.contrat.periode"
      v-bind:id="props.id" />
    <refonte-item-file-formateur-contrat-a-consulter
      v-else
      v-bind:title="props.title"
      v-bind:subtitle="props.subtitle"
      v-bind:contrat="props.contrat"
      v-bind:on_click_download="
        () => downloadContrat(props.contrat.clientId, props.contrat)
      "
      v-bind:on_close="props.on_close"
      v-bind:on_submit="props.on_submit"
      v-bind:client_id="props.contrat.clientId"
      v-bind:participant_nom_prenom="props.participant_nom_prenom"
      v-bind:session_date="props.session_date"
      v-bind:formation_title="props.contrat.periode"
      v-bind:id="props.id" />
  </template>

  <refonte-item-file
    v-bind:id="props.id"
    v-if="props.contrat.typeSignatureId == 2"
    v-bind:title="props.title"
    v-bind:subtitle="props.subtitle"
    v-bind:on_click_download="
      () => downloadContrat(props.contrat.clientId, props.contrat)
    "
    v-bind:file_signed="props.contrat.signe || props.contrat.valide"
    v-bind:file_signed_editable="false"
    v-bind:on_click_upload_refresh="props.on_submit"
    v-bind:signed_label="
      props.contrat.valide
        ? 'Validé'
        : props.contrat.signe
          ? 'Signé'
          : undefined
    "
    v-bind:version_label="props.contrat.valide ? 'validée' : undefined" />
</template>

<script setup lang="ts">
  import { downloadContrat } from '@/mixin/client_download__functions';
  import RefonteItemFile from '@/components/refonte/items/refonte-item-file.vue';
  import { Contrat } from '@/types/gestion/contrats-types';
  import RefonteItemFileFormateurContrat from '@/components/refonte/items/refonte-item-file-formateur-contrat.vue';
  import RefonteItemFileFormateurContratAConsulter from '@/components/refonte/items/refonte-item-file-formateur-contrat-a-consulter.vue';

  const props = withDefaults(
    defineProps<{
      id: string;
      class?: string;
      contrat: Contrat;
      on_submit?: Function;
      on_close?: Function;
      title?: string;
      subtitle?: string;
      participant_nom_prenom?: string;
      session_date?: string;
      formation_title?: string;
    }>(),
    {
      class: '',
      title: 'Contrat formateur'
    }
  );
</script>

<style lang="scss" scoped></style>
